<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
		<section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
				<div class="btns">
                    <el-button @click.stop="dialogVisibleCustomer = true" type="primary" size="small" icon="el-icon-upload" class="right">客户信息导入</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
				</table-pagination>
            </div>
        </section>

		<el-drawer 
			title="客户信息导入"
			:visible.sync="dialogVisibleCustomer"
			:wrapperClosable="false"
			:append-to-body="true"
			:modal-append-to-body="false"
			size="510px"
			direction="rtl">
			<CustomerImport v-if="dialogVisibleCustomer" @onEmitCustomerData="getList" />
		</el-drawer>

		<el-drawer 
			title="导入客户明细"
			:visible.sync="dialogVisibleCustomerDetail"
			:wrapperClosable="false"
			:append-to-body="true"
			:modal-append-to-body="false"
			size="800px"
			direction="rtl">
			<CustomerDetail v-if="dialogVisibleCustomerDetail" :row="row" />
		</el-drawer>
	</div>
</template>

<script>
import Vue from 'vue';
import { tableMixin } from "utils/mixins";
import CustomerImport from './components/CustomerImport';
import CustomerDetail from './components/CustomerDetail';
export default {
	mixins: [tableMixin],
	components: {CustomerImport, CustomerDetail},
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{
					label: '序号',
					width: 50,
					align: 'center',
					render: (h, scope) => {
						return (
							<span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
						)
					}
				},
				{label: '数据批次号', prop: 'customerBatchNo'},
				{label: '批次名称', prop: 'remark'},
				{label: '操作人', prop: 'accountName'},
				{
					label: '导入时间',
					render: (h, scope) => {
						return (
							<span>{formatDate(scope.row.createTime)}</span>
						)
					}
				},
				{
					label: '导入数据量',
					render: (h, scope) => {
						return (
							<div>
								<span style="color: #67C23A;">{scope.row.sendNum}</span> / <span>{scope.row.totalcount}</span>
							</div>
						)
					}
				},
				{ 
					label: '导入状态', 
					render: (h, scope) => {
						return (
							<el-tag size="mini" type={scope.row.status == 'done' ? 'success' : scope.row.status == 'failed' ? 'danger' : ''}>{scope.row.status == 'done' ? '导入成功' : scope.row.status == 'failed' ? '导入失败' : '导入中'}</el-tag>
						)
					}
				},
				{
                    label: '操作',
                    prop: 'cation',
                    width: 120,
                    fixed: 'right',
					align: 'center',
                    render: (h, scope) => {
						return (
							<div>
								<el-link onClick={() => this.handelView(scope.row)} type="primary" underline={false}>详情</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handelDownload(scope.row)} disabled={!scope.row.ftpBase} type="primary" underline={false}>下载</el-link>
							</div>
						)
                    }
                }
			],
			filterHeader: [
				{ label: '导入状态', model: 'status', type: 'select', default: '', list: [
					{id: 'doing', name: '导入中'},
					{id: 'done', name: '导入成功'},
					{id: 'failed', name: '导入失败'}
				] },
				{ label: '操作人', model: 'accountName', type: 'input', default: '', placeholder: '请输入操作人' },
				{ label: '备注', model: 'remark', type: 'input', default: '', placeholder: '请输入备注' },
				{ label: '导入时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
			],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				status: '',
				accountName: '',
				remark: '',
				date: [],
				createStartTime: '',
				createEndTime: ''
			},
			list: [],
			total: 0,
			dialogVisibleCustomer: false,
			dialogVisibleCustomerDetail: false,
			row: {}
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.dialogVisibleCustomer = false;
			this.$api.apiPostSmsImportLogList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response['list'];
				this.total = response.total;
			});
		},
		handelView(row) {
			this.row = row;
			this.dialogVisibleCustomerDetail = true;
		},
		handelDownload(row) {
			window.open(row.ftpBase);
		},
		filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		}
	}
}
</script>
